var render = function (_h,_vm) {var _c=_vm._c;return _c('Route',{staticClass:"MainLogo",attrs:{"exact":true,"title":_vm.$options.appName,"to":"Index"}},[_c('Pic',{attrs:{"alt":_vm.$options.appName,"src":_vm.$options.source(_vm.props)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }